import { FormattedMessage } from 'react-intl';
import { FilterItem } from '@molecules/filters/filtersMenu';
import { Qualification } from '@libs/models/talents';
import { FilterGeneral } from '@libs/store/filters';

type QualificationFilterMenuProps = {
  localizationSubset: string;
  options: Qualification[];
  getFilter: (key: string) => FilterGeneral<string[]> | null;
  key: string;
};
export function useQualificationsFilterMenu({
  localizationSubset,
  options,
  getFilter,
  key,
}: QualificationFilterMenuProps): FilterItem {
  const filter = getFilter(key);
  return {
    label: <FormattedMessage id={`${localizationSubset}.filters.${key}.label`} />,
    key: key,
    multiple: true,
    valueToLabel: (value) => value.map((v) => options.find((l) => l.id === v)?.name).join(', '),
    children: options.map((item) => ({
      label: item.abbreviation || item.name,
      key: item.id,
      selected: filter?.value.includes(item.id) || false,
    })),
  };
}
